import { MDBIcon } from 'mdbreact';
import React, { Component, createRef } from 'react';
import gsap from "gsap";
import { URLImgFront } from '../../config/URLDB';
import { Seguros_ } from '../../services/WebAPI_Utrahuilca';

class Personas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stateImg: false,
            stateOri: false
        };
        this.imgprinRef = createRef(); 
        this.rutaRef = createRef(); 
        this.bannerRef = createRef(); 
    }

    async componentDidMount() {
        const data = {
            tran: 7,
            idvtaseguro: 0,
            nombseguro: 'NA',
            rutafondoseg: 'NA',
            txtseguro1: 'NA',
            txtseguro2: 'NA',
            txtslider3: 'NA',
            posiciontexto: 0,
            colortexto: 'NA',
            estado: 1,
            usucrea: 'NA'
        };

        Seguros_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({ stateImg: false });
                        } else {
                            if (response.data[0].posiciontexto === 1) {
                                this.setState({ left: "5%", stateOri: true });
                            } else {
                                this.setState({ right: "8%", stateOri: false });
                            }
                            this.setState({
                                nombseguro: response.data[0].nombseguro,
                                rutafondoseg: response.data[0].rutafondoseg,
                                txtseguro1: response.data[0].txtseguro1,
                                txtseguro2: response.data[0].txtseguro2,
                                txtslider3: response.data[0].txtslider3,
                                posiciontexto: response.data[0].posiciontexto,
                                colortexto: response.data[0].colortexto,
                                stateImg: true
                            }, () => {
                                this.animacionEntrada();
                            });
                        }
                    } else {
                        this.setState({ stateImg: false }, () => this.animacionEntrada());
                    }
                } else {
                    this.animacionEntrada();
                }
            } catch (error) {
                this.animacionEntrada();
            }
        });
    }

    animacionEntrada = () => {
        const lineaTiempo = gsap.timeline({ defaults: { ease: "power3.out" } });

        if (this.imgprinRef.current) {
            lineaTiempo.fromTo(
                this.imgprinRef.current,
                { opacity: 0, scale: 1.05 },
                { opacity: 1, scale: 1, duration: 0.9 }
            );
        }

        lineaTiempo.fromTo(
            this.rutaRef.current,
            { opacity: 0, x: -30 },
            { opacity: 1, x: 0, duration: 0.5 },
            "-=0.4"
        );

        lineaTiempo.fromTo(
            this.bannerRef.current,
            { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 0.6 },
            "-=0.3"
        );
    };

    render() {
        const { stateImg } = this.state;
        return (
            <React.Fragment>
                <div className="diseño_responsive_view" style={{ width: '100%', paddingTop: '120px', backgroundColor: '#F5F2F2' }} >
                    {stateImg ? (
                        <div ref={this.imgprinRef}>
                            <img style={{ width: '100%', height: '70vh', marginBottom: '15px', objectFit: 'cover' }} className="img-fluid" src={`${URLImgFront}/assets${this.state.rutafondoseg}`} alt="img1" />
                        </div>
                    ) : (<></>)}
                    <span ref={this.rutaRef} className="ml-4 pt-4 font-weight-bold" style={{ fontSize: '20px', color: 'grey' }}>
                        <MDBIcon icon="caret-right" className="ml-2 mr-1" /> Personas <MDBIcon icon="caret-right" className="ml-2 mr-1" /> Seguros
                    </span>
                    <div ref={this.bannerRef} className="text-center mt-3 text-white seguro-banner" style={{ borderBottom: '12px solid #27A3B1', backgroundColor: '#37B3C1' }}>
                        <p> Conoce los beneficios y coberturas del <br /> portafolio de seguros y previsión exequial en alianza con <b style={{ fontWeight: '900' }}>UTRAHUILCA.</b> </p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Personas;